export const OPTHINES = {
  // 接口路径
  voteName: '2019poject/2019environmental',
  themeColor: {
    activeBgColor: 'rgb(44, 147, 68)',
    inactiveBgColor: '#ffffff',
  },
  placeholder: '搜索姓名/编号',
  tabs: [
    {
      tabName: '活动展示',
      tabPath: '/2019HBZYZPS/Activities',
    },
    {
      tabName: '相关新闻',
      tabPath: '/2019HBZYZPS/RelativeNews',
    },
    {
      tabName: '评选说明',
      tabPath: '/2019HBZYZPS/SelectRules',
    },
  ],
  mustSearch: 'Button',
  buttonBg: 'rgb(37,155,16)',
  number: {
    mustRank: false,
  },
  name: true,
  content: true,
  user: true,
  checkBox: false,
};
